import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setOpenFolders } from 'redux/actions'
import { RootState } from 'types'

import { useOpenedFoldersNamespaceKey } from './useOpenedFoldersNamespaceKey'

const useOpenedFolders = () => {
  const openFoldersNamespaceKey = useOpenedFoldersNamespaceKey()
  const openFolderIds = useSelector(({ openFolderIds }: RootState) => openFolderIds[openFoldersNamespaceKey] || [])
  const dispatch = useDispatch()

  const openFolders = useCallback(
    (folderKeys: string[]) => {
      dispatch(setOpenFolders(openFoldersNamespaceKey, [...openFolderIds, ...folderKeys]))
    },
    [dispatch, openFolderIds, openFoldersNamespaceKey],
  )

  const closeFolder = useCallback(
    (folderKey: string) => {
      dispatch(
        setOpenFolders(
          openFoldersNamespaceKey,
          openFolderIds.filter((id: string) => folderKey !== id),
        ),
      )
    },
    [dispatch, openFolderIds, openFoldersNamespaceKey],
  )

  return {
    openFolderIds,
    openFolders,
    closeFolder,
  }
}

export { useOpenedFolders }
